var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Meta',{attrs:{"title-placeholder":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }